import InputCheckbox from "@/components/form/input-checkbox";
import { COOKIE, DEFAULT_SETTINGS, getSettings } from "@/components/settings";
import { useSidebar } from "@/context/sidebar-context";
import { useEffect, useState } from "react";
import Icon from "../../icon";
import SidebarMenu from "./sidebar-menu";

const SidebarSettings = () => {
  const { close, open } = useSidebar();

  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  useEffect(() => {
    setSettings(getSettings());
  }, []);

  return (
    <div className="container h-full pt-8 px-6 space-y-6">
      <div className="flex justify-between items-center">
        <button
          className="btn-icon h-10 w-10"
          onClick={() => open(<SidebarMenu />)}
          aria-label="Gå tillbaka"
          title="Gå tillbaka"
        >
          <Icon.AngleLeft className="rotate-180 fill-gray-300 h-4" />
        </button>

        <h2 className="font-bold font-noto-sans text-lg">
          Tillgänglighetsmeny
        </h2>

        <button
          className="btn-icon h-10 w-10"
          onClick={close}
          aria-label="Stäng meny"
          title="Stäng meny"
        >
          <Icon.Close className="fill-gray-300 h-4" />
        </button>
      </div>

      <form
        className="space-y-4"
        onSubmit={(e) => {
          e.preventDefault();

          const formData = new FormData(e.currentTarget);

          const settings = {
            letterSpacing: Boolean(formData.get("letterSpacing")),
            wordSpacing: Boolean(formData.get("wordSpacing")),
            paragraphSpacing: Boolean(formData.get("paragraphSpacing")),
            lineHeight: Boolean(formData.get("lineHeight")),
            disableAnimations: Boolean(formData.get("disableAnimations")),
          };

          localStorage.setItem(COOKIE, JSON.stringify(settings));
          window.location.reload();
        }}
      >
        <InputCheckbox
          text="Utökat teckenavstånd"
          defaultValue={settings.letterSpacing}
          name="letterSpacing"
        />

        <InputCheckbox
          text="Utökat ordmellanrum"
          defaultValue={settings.wordSpacing}
          name="wordSpacing"
        />

        <InputCheckbox
          text="Utökat radavstånd"
          defaultValue={settings.lineHeight}
          name="lineHeight"
        />

        <InputCheckbox
          text="Större styckeavstånd"
          defaultValue={settings.paragraphSpacing}
          name="paragraphSpacing"
        />

        <InputCheckbox
          text="Stäng av rörelser och animationer"
          defaultValue={settings.disableAnimations}
          name="disableAnimations"
        />

        <div className="space-x-2">
          <button
            type="button"
            className="btn"
            onClick={() => {
              localStorage.removeItem(COOKIE);
              window.location.reload();
            }}
          >
            Återställ inställningar
          </button>

          <button type="submit" className="btn btn-comp">
            Spara
          </button>
        </div>
      </form>
    </div>
  );
};

export default SidebarSettings;
